import styled from 'styled-components';
import Image from '../../common/Image/Image';
import AskIcon from '../../../../../stories/Icons/AskIcon';

export const SuperDealDetailWrapper = styled.div(
  props => `
    display: flex;
    flex-direction:column;
    margin-bottom:${props.theme.spacing.base};
    background-color:${props.bgColor || props.theme.colors.goYellow.light};
    padding:${props.theme.spacing.base};
    border-radius: ${props.theme.misc.borderRadius.custom(8)};
  `,
);

export const OptionList = styled.ul(
  props => `
    display:flex;
    flex-direction:column;
    >li{
        display:flex;
        align-items:baseline;
        padding-bottom:${props.theme.spacing.small};
        &:last-child{
            padding-bottom:0;
        }
      }
    `,
);

export const BulletPoint = styled.span(
  props => `
    background-color:${props.theme.colors.downriver.base};
    // border-radius: ${props.theme.misc.borderRadius.xxxlarge};

    border-radius: 50%;
    width: 0.6rem;
    height: 0.6rem;
    margin-right: ${props.theme.spacing.small};
    `,
);

export const BulletTextSpan = styled.span(
  props => `
    font-size:${!props.isMultiRoom ? props.theme.font.custom(14) : '12px'};
    `,
);

export const BulletPointOuter = styled.div(
  props => `
    display:flex;
    width:6%;
    `,
);

export const ShowMoreWrapper = styled.div(
  props => `
    padding-left: 1rem;
    padding-top: 0.5rem;
    `,
);

export const BulletTextOuter = styled.span(
  props => `
    display:flex;
    width:95%;
    `,
);

export const GotribeImgWrapper = styled(Image)(
  props => `
      display:flex;
      padding-bottom:${props.theme.spacing.small};
      min-width:10.5rem;
      max-width: 13rem;
      height:2.5rem;
      object-fit: fill;
    `,
);

export const DealNewWrap = styled(AskIcon)(
  props => `
        width:1rem;
        height:1rem;
        fill:${props.theme.colors.goWhite.base};
        margin-right:${props.theme.spacing.small};
    `,
);

export const SuperDealPersuationWrapper = styled.div(
  props => `
    display: flex;
    width: ${props.isMultiRoom ? '64%' : '45%'};
    align-items:center;
    margin-bottom:${props.theme.spacing.base};
    background-color:${props.bgColor || props.theme.colors.goPurple.base};
    color:${props.textColor || props.theme.colors.goWhite.base};
    // padding:${props.theme.spacing.xsmall} ${props.theme.spacing.base};
    padding:5px ${props.theme.spacing.base};
    border-radius: ${props.theme.misc.borderRadius.xxxlarge};
    boredr-color: ${props.borderColor || ''}
    font-weight: 600;
    `,
);

export const SubjectiveText = styled.div(
  props => `
    color: #777;
    padding-left: 0.5rem;
    `,
);

export const ShowMoreText = styled.div(
  props => `
    color: ${props.themecolors.ash.base};
    padding-left: 0.5rem;
    `,
);
